import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

export default function RejectedReview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/rejected-review").then(r => setData(r.data)).catch(() => setData({ rows: [], count: 0 })); }, []);
  return (
    <div className="p-6 lg:p-8" data-testid="rejected-review-page">
      <div className="text-xs uppercase tracking-widest text-slate-500 font-medium">Reports · Read-only</div>
      <h1 className="font-display text-3xl font-extrabold mt-1">Rejected — maybe meant as Send back</h1>
      <p className="text-sm text-slate-500 mt-1 mb-4">Rejected items whose reason asks for a correction. Nothing here is changed; review each with the reviewer and the requester can use “Copy as new claim”.</p>
      {!data ? <div className="text-sm text-slate-500">Loading…</div> : (
        <Card><CardContent className="p-0 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-500 bg-slate-50"><tr className="border-b">
              {["Type", "Reference", "Requester", "Amount", "Rejected by", "Date", "Reason", "Matched words"].map(h => <th key={h} className="text-left px-3 py-2">{h}</th>)}
            </tr></thead>
            <tbody>
              {data.rows.length === 0 && <tr><td colSpan={8} className="text-center px-3 py-10 text-slate-500" data-testid="rr-empty">No rejected items look like they needed a send back.</td></tr>}
              {data.rows.map(r => (
                <tr key={r.id} className="border-b border-slate-100 align-top" data-testid={`rr-row-${r.reference}`}>
                  <td className="px-3 py-2 capitalize">{r.kind}</td>
                  <td className="px-3 py-2 font-mono text-xs">{r.reference}{r.inv_ref && r.inv_ref !== r.reference ? <div className="text-indigo-700">{r.inv_ref}</div> : null}</td>
                  <td className="px-3 py-2">{r.requester_name}</td>
                  <td className="px-3 py-2 font-mono">₹ {Number(r.amount || 0).toLocaleString("en-IN")}</td>
                  <td className="px-3 py-2">{r.rejected_by || "—"}</td>
                  <td className="px-3 py-2 font-mono text-xs">{(r.rejected_at || "").slice(0, 10)}</td>
                  <td className="px-3 py-2 text-red-800">{r.reason}</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{r.hints.join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent></Card>
      )}
    </div>
  );
}
